import SuggestionPanelComponent, { SUGGESTION_PANEL_BASE_HTML_CLASS } from "./suggestion_panel_component";

// VerifyPanel — enter the emailed code. Verifying signs the submitter in and the host then
// POSTs the suggestion (upload-last). Resend is rate-limited by the AuthClient's cooldown,
// counted down here. Skip submits anonymously with no code (the Rankometer's escape hatch);
// Back returns to the identity step to correct the address.
export class VerifyPanel extends SuggestionPanelComponent {
  static get config() {
    return {
      componentTypeKey: "SuggestionVerifyPanel",
      baseHtmlClass: SUGGESTION_PANEL_BASE_HTML_CLASS,
      selector: ".suggestion_panel__panel--verify",
      phase: "verify",

      codeInputSelector: "input[name='code']",
      resendSelector: ".suggestion_panel__resend",
      skipSelector: ".suggestion_panel__skip",
      backSelector: ".suggestion_panel__back",
      statusSelector: ".suggestion_panel__status",
    };
  }

  constructor(id_or_element, host) {
    super(id_or_element, host, VerifyPanel.config);
    const config = VerifyPanel.config;

    this.codeInput = this.element.querySelector(config.codeInputSelector);
    this.resendButton = this.element.querySelector(config.resendSelector);
    this.statusEl = this.element.querySelector(config.statusSelector);

    this.element.addEventListener("submit", (event) => {
      if (event) event.preventDefault();
      this.host.submitCode(this.codeInput ? this.codeInput.value : "");
    });

    if (this.resendButton) this.resendButton.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.resendCode();
    });

    const skip = this.element.querySelector(config.skipSelector);
    if (skip) skip.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.skipAuth();
    });

    const back = this.element.querySelector(config.backSelector);
    if (back) back.addEventListener("click", (event) => {
      if (event) event.preventDefault();
      this.host.changeEmail();
    });

    // The resend cooldown counts down live. The interval ticks only while this panel is the
    // one showing (renderResend no-ops otherwise); it outlives the element, so onDestroy.
    this.resendTimer = setInterval(() => this.renderResend(), 1000);
    this.onDestroy(() => clearInterval(this.resendTimer));
  }

  render() {
    const isActive = this.renderPanelVisibility();
    this.applyBusy([this.codeInput]);
    this.renderAuthStatus(this.statusEl);
    this.renderResend();
    return isActive;
  }

  // "Resend code" enabled once the cooldown lapses; a live "(42s)" countdown otherwise. Only
  // meaningful while showing — a hidden panel's resend button is off-screen.
  renderResend() {
    if (!this.resendButton) return;
    if (this.readStateMachineValue("phase") !== VerifyPanel.config.phase) return;

    const canResend = this.host.canResend();
    const seconds = this.host.resendSecondsRemaining();
    const busy = !!this.readStateMachineValue("authBusy");
    this.resendButton.disabled = busy || !canResend;
    this.resendButton.textContent = canResend ? "Resend code" : `Resend code (${seconds}s)`;
  }
}
